const mimeTypes = {
  'audio/aac': 'aac',
  'audio/mp4': 'mp4',
  'audio/mpeg': 'mp3',
  'audio/ogg': 'ogg',
  'audio/wav': 'wav',
  'audio/webm': 'webm',
  'image/gif': 'gif',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/svg+xml': 'svg',
  'image/tiff': 'tiff',
  'image/webp': 'webp',
  'text/csv': 'csv',
  'text/html': 'html',
  'text/plain': 'txt',
  'text/css': 'css',
  'text/javascript': 'js',
  'application/json': 'json',
  'application/pdf': 'pdf',
  'application/zip': 'zip',
  'application/x-rar-compressed': 'rar',
  'application/msword': 'doc',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/octet-stream': 'bin',
  'application/xml': 'xml',
  'application/rtf': 'rtf',
  'application/x-www-form-urlencoded': 'urlencoded',
  'application/x-shockwave-flash': 'swf',
  'video/mp4': 'mp4',
  'video/ogg': 'ogv',
  'video/webm': 'webm',
  'video/x-msvideo': 'avi',
  'video/quicktime': 'mov',
  'application/x-font-woff': 'woff',
  'application/x-font-woff2': 'woff2',
  'application/font-woff': 'woff',
  'application/font-woff2': 'woff2',
  'application/vnd.ms-fontobject': 'eot',
  'application/x-font-ttf': 'ttf',
  'font/ttf': 'ttf',
  'application/x-font-otf': 'otf',
  'font/otf': 'otf',
  'application/vnd.oasis.opendocument.text': 'odt',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.oasis.opendocument.presentation': 'odp',
  'application/epub+zip': 'epub',
  'application/x-ruby': 'rb',
  'text/x-python': 'py',
  'application/x-java-archive': 'jar',
  'application/javascript': 'js',
  'application/x-msexcel': 'xls',
  'application/x-dvi': 'dvi',
  'application/vnd.ms-office': 'doc',
  'application/x-tar': 'tar',
  'application/x-bzip2': 'bz2',
  'application/x-gzip': 'gz',
  'application/x-msdownload': 'exe',
  'application/x-latex': 'latex',
};

export const getExtensionByMimeType = (mimeTypeString: string, withDot?: boolean): string | undefined => {
  const mimeType = mimeTypes[mimeTypeString];

  if (!mimeType) return;

  return withDot ? `.${mimeType}` : mimeType;
};
